"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Util = /** @class */ (function () {
    function Util() {
    }
    /**
     * Time constant comparison of two arrays
     *
     * @param {Uint8Array} lh First array of bytes
     * @param {Uint8Array} rh Second array of bytes
     * @return {Boolean} True if the arrays are equal (length and content), false otherwise
     */
    Util.compare = function (lh, rh) {
        if (lh.length !== rh.length) {
            return false;
        }
        var i;
        var d = 0;
        var len = lh.length;
        for (i = 0; i < len; i++) {
            d |= lh[i] ^ rh[i];
        }
        return d === 0;
    };
    Util.normalizeUTF8 = function (str) {
        return str ? str.normalize('NFKD') : '';
    };
    return Util;
}());
exports.default = Util;
